import React from 'react';

export interface PageTitleProps {
    children: React.ReactNode;
    margin?: string;
    className?: string;
    style?: React.CSSProperties;
}

const PageTitle: React.FC<PageTitleProps> = ({
    children,
    margin = '0',
    className = '',
    style = {},
}) => {
    const titleStyles: React.CSSProperties = {
        fontSize: '24px',
        fontWeight: 600,
        color: 'var(--malachite-text-primary)',
        lineHeight: '1.3',
        margin,
        ...style,
    };

    return (
        <h1 className={className} style={titleStyles}>
            {children}
        </h1>
    );
};

export default PageTitle;
